import { DATA_TYPES_LIST, LOCAL_VARIABLE_ACTION_FIELDS_VALUES } from 'constants/Variables';

/**
 * Normalizes a local variable action block that was saved in the old (incorrect) token format.
 * Old format stored the value field as an array of objects [{checked, text, value}].
 * New format stores the value field as a single selected string.
 * Called on entry to edit mode so that all subsequent code works with one consistent format.
 * @param {object} item - raw meshbot action block from the scene's then/else array
 * @returns {object} - item with token value field normalized to a string if needed
 */
export const normalizeLocalVariableTokenFields = (item) => {
    const valueField = item.fields?.find((field) => field.name === LOCAL_VARIABLE_ACTION_FIELDS_VALUES.VALUE);

    if (!valueField || valueField.type !== DATA_TYPES_LIST.TYPE_TOKEN || !Array.isArray(valueField.value)) {
        return item;
    }

    const selectedValue = valueField.value.find((el) => el?.checked)?.value ?? '';

    return {
        ...item,
        fields: item.fields.map((field) =>
            field.name === LOCAL_VARIABLE_ACTION_FIELDS_VALUES.VALUE ? { ...field, value: selectedValue } : field,
        ),
    };
};
